import { useMemo } from 'react';
import { useAppSelector } from 'store/hooks';
import { isWithdrrawalRejectOpened } from 'store/slices/withdrawalReject';
import { getWidgetLocation } from 'utils';

import { FORCED_SHOW_HEADER_PATHS } from '../constants';

interface showHeaderProps {
  curLocation: { pathname: string };
  hideNav?: boolean;
}

export const useShowHeader = ({ hideNav, curLocation }: showHeaderProps) => {
  const isWithdrawalRejectOpened = useAppSelector(isWithdrrawalRejectOpened);

  return useMemo(() => {
    if (isWithdrawalRejectOpened) {
      return false;
    }

    const currentLocation = getWidgetLocation(curLocation.pathname);

    const isForcedVisible = FORCED_SHOW_HEADER_PATHS.some((pathKey) => currentLocation[pathKey]);

    return isForcedVisible || !hideNav;
  }, [curLocation.pathname, hideNav, isWithdrawalRejectOpened]);
};
